// @flow

import React from 'react';

import _ from 'underscore';

import Tbutton from './Tbutton';

import t from '../trans';

import DiagnosticsStore from "../stores/DiagnosticsStore";
import DiagnosticsActions from "../actions/DiagnosticsActions";


class Diagnostics extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			diagnostics: DiagnosticsStore.getState(),
			intervalId: null,
			delay: 1
		};

		this.onChange = this.onChange.bind(this);
		this.onClickLoad = this.onClickLoad.bind(this);
	}

	componentDidMount() {
		DiagnosticsStore.listen(this.onChange);

		DiagnosticsActions.fetch.defer();
	}

	componentWillUnmount() {
		if (this.state.intervalId) {
			clearInterval(this.state.intervalId);
			this.setState({intervalId: null});
		}
		DiagnosticsStore.unlisten(this.onChange);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.diagnostics.state === "PROCESSING" && this.state.diagnostics.state !== "PROCESSING") {
			// loading or saving finished
			if (this.state.diagnostics.state === "FAIL" && this.state.intervalId != null) {
				// Request fails. Turn off automatic updates:
				clearInterval(this.state.intervalId);
				this.setState({intervalId: null});
				return;
			}
		}
		if (this.state.intervalId == null && this.state.delay > 0 && this.state.diagnostics.state !== "FAIL") {
			// Enable automatic data reloading:
			this.setState({
				intervalId: setInterval(this.onClickLoad, this.state.delay*1000)
			});
		}
	}

	onChange(state) {
		if (this.state.intervalId == null && this.state.delay > 0) {
			// Enable automatic data reloading:
			this.setState({
				diagnostics: _.clone(state),
				intervalId: setInterval(this.onClickLoad, this.state.delay*1000)
			});
		} else {
			this.setState({
				diagnostics: _.clone(state)
			});
		}
	}

	onClickLoad() {
		DiagnosticsActions.fetch.defer();
	}

	render() {
		return (
			<div className="container-fluid">
				<form className="form-horizontal">
					<table className="table table-hover">
						<thead>
							<tr>
								<th className="col-sm-4">{t("Parameter")}</th>
								<th className="col-sm-8">{t("Value")}</th>
							</tr>
						</thead>
						<tbody>
							{this.renderItems()}
						</tbody>
					</table>
				</form>
			</div>
        );
	}

	renderItems() {
		let items = this.getItems();

		let result = [];
		for (let item of items) {
			let renderedItem = this.renderItem(item);
			if (renderedItem != null) result.push(renderedItem);
		}
		return result;
	}

	renderItem(item) {
		return (
			<tr key={item.name}>
				<td>{t(item.name)}</td>
				<td>{item.value}</td>
			</tr>
		);
	}


	getItems() {
		return this.state.diagnostics.diagnostics;
	}

}

export default Diagnostics;
